import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import ThumbnailButtonGroup from '../thumbnailButtonGroup/thumbnailButtonGroup';

var ColoredDiv = function ColoredDiv(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'control-thumbnail-color-input-item ' + (props.isSelected ? 'selected-item' : ''),
    style: {
      backgroundColor: props.color
    }
  });
};

var getOptions = function getOptions(_ref) {
  var options = _ref.options,
      selectedIndex = _ref.selectedIndex;
  return _.map(options, function (opt, i) {
    return _.defaults({
      illustration: ColoredDiv({
        color: opt.color,
        isSelected: selectedIndex === i
      }),
      onClick: function onClick() {
        return opt.onClick(opt, i);
      }
    }, opt);
  });
};

var ThumbnailColorInput = function ThumbnailColorInput(_ref2) {
  var options = _ref2.options,
      selectedIndex = _ref2.selectedIndex,
      maxThumbsPerRow = _ref2.maxThumbsPerRow;
  return /*#__PURE__*/React.createElement(ThumbnailButtonGroup, {
    className: "control-thumbnail-color-input",
    options: getOptions({
      options: options,
      selectedIndex: selectedIndex
    }),
    maxThumbsPerRow: maxThumbsPerRow
  });
};

ThumbnailColorInput.displayName = displayNames.THUMBNAIL_COLOR_INPUT;
ThumbnailColorInput.propTypes = {
  /** The colors to display */
  options: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  })).isRequired,

  /** The index of the selected color */
  selectedIndex: PropTypes.number,

  /** Maximum number of colors per row. Should not exceed 5. */
  maxThumbsPerRow: PropTypes.number.isRequired
};
export default compose(ThumbnailColorInput);